import moment from "moment"

export const __OBJECT_STRUCTURE_GetFilter = () => {
    let range = [moment().subtract(1, 'month').startOf('month').toDate(), moment().subtract(1, 'month').endOf('month').toDate()]

    return {
        calendarSelectorId: 4,
        displayAgregationId: 1,
        periodId: 0,
        periodStartDate: range[0],
        periodEndsDate: range[1],
        fireFilter: true
    }
}

export const __OBJECT_STRUCTURE_GetConsolidation = () => {
    return {
        id : null,
        code : null,
        name : null,
        wildcard : null,
        asocciatedValue : null,
    }
}

export const __OBJECT_STRUCTURE_GetBoarScope = () => {
    return {
        id : 0,
        scopeNemo : '',
        scopeCode : '',
        name : null,
        perspectiveId : 0,
        boardId : 0,
        deactivate : null,
    }
}

export const __OBJECT_STRUCTURE_GetDataserieValue = (dataserieId) => {
    return {
        id : null,
        dataserieId : dataserieId,
        wildcard : null,
        dd : null,
        mm : null,
        yyyy : null,
        periodId : null,
        serieTime : null/*DateTime*/,
        valueReal : null,
        valueProvisory : null,
        valueBudget : null,
        valueForecast : null,
        valueGoal : null,
        valueGoalPercent : null,
        valueZero : null,
        locked : false,
        closeProcessId : null,
        v1 : null,
        v2 : null,
        k1 : null,
        k2 : null,
        formula : '',
        formulaDesc : '',
    }
}

export const __OBJECT_STRUCTURE_GetRevision = (dataserieId) => {
    return {
        id: null,
        title: "",
        statusId: 1,
        referenceDate: null,
        l_action_ids: [],
        l_gap_ids: []
    }
}


export const __OBJECT_STRUCTURE_ContractModification = () => {
    return {
        id: 0,
        changeCode: null,
        changeSecNumber: null,
        contractId: null,
        contractingModalityId: null,
        reason: null,
        scope: null,
        amount: null,
        endowment: null,
        startDate: null,
        term: null,
        modificationScope: false,
        modificationAmount: false,
        modificationTerm: false,
        modificationEndowment: false,
    }
};

export const __OBJECT_STRUCTURE_BoardFilters = (filterType="contract") => {
    return {
		l_codes: [],
		filter_type: filterType,
		contractFilterList: [],
        filter_text: ""
    }
};

export const __OBJECT_STRUCTURE_GetBoard = () => {
    return {
        "id": null,
        "boardCode": null,
        "name": null,
        "owner": null,
        "timeAggregationId": 0,
        "displayCurrency": "0",
        "numberFix": 0,
        "creationDate": null,
        "l_structure": [
            {
                "id": null,
                "templateId": 0,
                "boardId": 0,
                "htmlId": "",
                "htmlStructure": null,
                "l_container": [
                {
                    "id": null,
                    "structureId": 0,
                    "htmlId": "",
                    "htmlContainer": null,
                    "l_components": [
                    {
                        "id": null,
                        "boardElementDataserieId": 0,
                        "boardId": 0,
                        "containerId": 0,
                        "componentTypeId": 0,
                        "htmlId": "",
                        "htmlStyle": null,
                        "htmlOnclick": null,
                        "htmlBoardAnexoRef": null,
                        "dataserieId": 0
                    }
                    ],
                    "l_components_info": [
                    {
                        "id": null,
                        "containerId": 0,
                        "boardElementId": 0,
                        "boardId": 0,
                        "componentTypeId": 0,
                        "htmlId": "",
                        "htmlStyle": null,
                        "elementId": 0
                    }
                    ]
                }
                ]
            }
        ]
    }
}

export const __OBJECT_STRUCTURE_GetGAP = () => {
    return {
        id: null,
        gapAnalyzeNemo: null,
        gapAnalyzeCode: null,
        name: null,
        statusId: null,
        creationDate: null,
    }
}

export const __OBJECT_STRUCTURE_globalNumberConfig = () => {
    return {
        decimalsLimit: 5,
        decimalSeparator: ",",
        groupSeparator: ".",
    }
}

export const __OBJECT_STRUCTURE_GetAction = () => {
    return {
        id: null,
        owner: null,
        executor: null,
        title: null,
        action: null,
        statusId: null,
        beginDate: null,
        endDate: null,
        deactivate: null,
        l_GapCauseId: [],
        l_gapRevisionId: [],
    }
}


export const __OBJECT_STRUCTURE_GetPrivilegeMatrix = () => {
    return { matrix: null, roles: null, actions: null, privileges: null }
}

//PAY

export const __OBJECT_STRUCTURE_GetPolynomy = () => {
    return {
        id: null,
        tipoPolinomioId: null,
        tipoPolinomioTitle: null,
        ponderador: null,
        fechaBase: null,
        valorBase: null,
        mesesDesfase: null,
        periodicidadMeses: null,
        primerMesReajuste: null,
    }
}

export const __OBJECT_STRUCTURE_ContractPartie = (elementId) => {
    return {
        id: 0,
        elementId: elementId,
        cantidadPreviaServicio: 0,
        cantidadTotalServicio: 0,
        clasePartidaId: 0,
        clasePartidaTitle: "",
        claseTipoPartidaId: 0,
        codigoContrato: "",
        codigoPartida: "",
        gastoPrevioBasePartida: 0,
        gastoPrevioDiftcPartidaMc: 0,
        gastoPrevioReajustePartida: 0,
        idMcContrato: 0,
        idMonedaContrato: 0,
        idMonedaPartida: 0,
        l_polinomios: [],
        mcNombre: "",
        mesInicioPartida: "0000/00",
        mesPrevio: "0000/00",
        mesTerminoPartida: "0000/00",
        monedaContrato: "",
        monedaPartida: "",
        montoTotalPartida: 0,
        montoTotalSumaAlzadaPartida: 0,
        nombrePartida: "",
        nroPartida: 0,
        precioUnitarioBasePartida: 0,
        tipoPartidaId: 0,
        tipoPartidaTitle: "",
        unidadPartidaId: 0,
        unidadPartidaTitle: "",
    }
}

export const __OBJECT_STRUCTURE_ContractSubPartie = (partidaId) => {
    return {
        id: 0,
        partidaId: partidaId,

        cantidadPreviaRecurso: 0,
        cantidadTotalRecurso: 0,
        clasePartidaId: 0,
        clasePartidaTitle: "",
        claseTipoPartidaId: 0,
        codigoRecurso: "",
        gastoPrevioBaseRecurso: 0,
        gastoPrevioDiftcRecursoMc: 0,
        gastoPrevioReajusteRecurso: 0,
        l_polinomios: [],
        montoTotalSumaAlzada: 0,
        nombreRecurso: "",
        nroRecurso: 0,
        precioUnitarioBaseRecurso: 0,
        tipoPartidaId: 0,
        tipoPartidaTitle: "",
        unidadPartidaId: 0,
        unidadPartidaTitle: "",
    }
}